export default {
  xhrRequest: function (params, type = "get", url, cb) {
    function createXHR() {
      if (typeof XMLHttpRequest != "undefined") {
        return new XMLHttpRequest();
      } else if (window["ActiveXObject"]) {
        return new window["ActiveXObject"]("Microsoft.XMLHttp");
      } else {
        throw new Error("无可用XHR");
      }
    }

    var xhr = createXHR();
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          // console.log("请求成功", xhr.responseText);
          const res = JSON.parse(xhr.responseText);
          cb && cb(res.data);
        } else {
          console.log("请求失败！");
        }
      }
    };
    xhr.open(type, url, true);
    xhr.send(JSON.stringify(params));
  },

  getPfVal: function () {
    function IsPC() {
      let userAgentInfo = navigator.userAgent;
      let Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }

    // 1、PC浏览器、2、PC政务微信、3移动政务微信 4其他
    let result = 4;
    let ua = String(window.navigator.userAgent).toLocaleLowerCase();

    // PC Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/605.1.15 (KHTML, like Gecko) wxwork/1.2.2 (MicroMessenger/6.2) WeChat/2.0.4
    // mobile Mozilla/5.0 (iPhone; CPU iPhone OS 12_0_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/16A404 wxwork/1.3.9 wwlocal/1.4.2 wxworklocal/1.4.2 MicroMessenger/6.3.22 wwlocal/1.0

    if (ua.indexOf("wxwork") !== -1) {
      // 政务微信
      if (ua.indexOf("iphone") === -1 && ua.indexOf("android") === -1) {
        // 手机端
        result = 3;
      } else {
        // pc政务微信
        result = 2;
      }
    } else {
      if (IsPC()) {
        // 是否为PC
        result = 1;
      }
    }

    return result;
  },

  loadScript: function (src, callback) {
    let script = document.createElement("script");
    script["async"] = "async";
    script["src"] = src;
    script["onload"] = callback || function () {};
    document.getElementsByTagName("head")[0].appendChild(script);
  },
};
